import MedusaApiClient from "@lib/clients/medusa-api-client"
import { baseHeaders, MEDUSA_BACKEND_URL } from "@lib/constants"

export const medusaClient = new MedusaApiClient({
  baseUrl: MEDUSA_BACKEND_URL,
  maxRetries: 3,
  customHeaders: baseHeaders,
})
